import { SelectArrayInput, SelectArrayInputProps } from 'react-admin';
import { Flag } from '../../utils';
import { createBitmaskParser } from './utils';

interface BitmaskTagsFilterProps extends Omit<SelectArrayInputProps, 'choices' | 'parse'> {
  flags: Flag[];
}

export default function BitmaskTagsFilter({ flags, source, ...rest }: BitmaskTagsFilterProps) {
  return (
    <SelectArrayInput
      choices={flags}
      source={source}
      parse={createBitmaskParser(flags)}
      {...rest}
    />
  );
}
